module.exports = __webpack_public_path__ + "static/img/vip_privilege12.f39aae8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip/vip_privilege12.png
// module id = HM77
// module chunks = 0